var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55 0C1.15201 0 0 1.152 0 2.55V14.45C0 15.848 1.15201 17 2.55 17H21.25C22.648 17 23.8 15.848 23.8 14.45V2.55C23.8 1.152 22.648 0 21.25 0H2.55ZM2.69167 1.7H21.0995L12.4755 9.65991C12.0715 10.0328 11.7099 10.0326 11.3068 9.65991L2.69167 1.7ZM1.7 3.09009L10.1469 10.9083C11.1217 11.8097 12.6605 11.8083 13.6354 10.9083L22.1 3.09009V14.45C22.1 14.9356 21.7356 15.3 21.25 15.3H2.55C2.06441 15.3 1.7 14.9356 1.7 14.45V3.09009Z",
    fill: "#EF8B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.00e12efd4cca8dddbab6d095e665dd97.svg";
export { ForwardRef as ReactComponent };